<script>
import request from "@/services/request";
import { mapActions } from "vuex";

export default {
    name: "ModalMoveProgramGroupUser",

    data() {
        return {
            loading: false,
            form: {
                program_group_user_id: "",
                new_program_group_id: "",
            },
            current_user: null,
            current_group: null,
            groups: [],
        };
    },

    computed: {
        targetGroups() {
            if (!this.current_group) return [];

            return this.groups.filter(g => Number(g.id) !== Number(this.current_group.id));
        }
    },

    methods: {
        openModal(data) {
            this.form.program_group_user_id = data.user.id;
            this.form.new_program_group_id = "";
            this.current_user = data.user;
            this.current_group = data.current_group;
            this.groups = data.groups;

            this.$modal.show("modalMoveProgramGroupUser");
        },

        closeModal() {
            this.form.program_group_user_id = "";
            this.form.new_program_group_id = "";
            this.current_user = null;
            this.current_group = null;
            this.groups = [];
            this.$modal.hide("modalMoveProgramGroupUser");
        },

        async saveMove() {
            if (!this.form.new_program_group_id) {
                this.errorNotification("Selecciona el grupo destino");
                return;
            }

            this.loading = true;

            try {
                const { data } = await request.post("/program-group-users/move", this.form);

                this.successNotification(data.message || "Usuario movido correctamente");
                this.closeModal();

                Event.$emit("event-reload-program-relations");
            } catch (error) {
                this.errorNotification(error);
            }

            this.loading = false;
        },

        ...mapActions({
            errorNotification: "alert/error",
            successNotification: "alert/success",
        }),
    },

    created() {
        Event.$on("event-open-move-program-group-user", (data) => {
            this.openModal(data);
        });
    }
};
</script>
<template>
    <modal
        name="modalMoveProgramGroupUser"
        :width="400"
        :height="'auto'"
        :click-to-close="false"
    >
        <div class="modal-header">
            <h5 class="modal-title">Mover usuario</h5>
        </div>

        <div class="modal-body" v-if="current_user">
            <div class="form-group mb-2">
                <label><strong>Usuario</strong></label>
                <input
                    type="text"
                    class="form-control"
                    :value="`${current_user.user?.name || ''} ${current_user.user?.last_name || ''}`"
                    readonly
                >
            </div>

            <div class="form-group mb-2">
                <label><strong>Grupo actual</strong></label>
                <input
                    type="text"
                    class="form-control"
                    :value="current_group?.name || ''"
                    readonly
                >
            </div>

            <div class="form-group mb-3">
                <label><strong>Mover a grupo</strong></label>
                <select v-model="form.new_program_group_id" class="form-control">
                    <option value="">Seleccione</option>
                    <option v-for="g in targetGroups" :key="g.id" :value="g.id">
                        {{ g.name }}
                    </option>
                </select>
            </div>

            <div class="text-right">
                <button class="btn btn-secondary btn-sm mr-2" @click="closeModal" :disabled="loading">
                    Cancelar
                </button>
                <button class="btn btn-primary btn-sm" @click="saveMove" :disabled="loading">
                    {{ loading ? 'Moviendo...' : 'Mover' }}
                </button>
            </div>
        </div>
    </modal>
</template>